import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import type { MantineSize, GridColProps } from '@mantine/core'
import { getPortDef, sizes, margins, paddings } from '@shared/port-v1.0.0'
import Comp from '../component'

export type Props = BaseReactProps & {
	columnsScheme?: Partial<GridColProps>[]
	childIsRepeater?: boolean
	gridColumnsCount?: number
	grow?: boolean
	w?: string
	h?: string
	gutter?: MantineSize
	align: 'stretch' | 'flex-start' | 'center' | 'flex-end'
	justify: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around'
}

export default {
	hashTag: '#pre-release',
	module: { static: Comp },
	inNode: {
		inputs: [
			
			getPortDef({
				name: 'columnsScheme',
				displayName: 'Columns scheme',
				group: 'Params',
				type: 'array',
				validate: (p: Props) => !!p.columnsScheme,
			}),
			getPortDef({
				name: 'childIsRepeater',
				displayName: 'Child is repeater',
				group: 'Params',
				type: 'boolean',
				default: false
			}),

			getPortDef({ name: 'grow', displayName: 'Grow', group: 'Dimensions', type: 'boolean' }),
			getPortDef({ name: 'w', displayName: 'Width', group: 'Dimensions', type: 'string', default: '100%' }),
			getPortDef({ name: 'h', displayName: 'Height', group: 'Dimensions', type: 'string' }),



			getPortDef({
				name: 'gridColumnsCount',
				displayName: 'Columns count',
				group: 'Layout',
				type: 'number',
				default: 12,
			}),
			getPortDef({
				name: 'gutter',
				displayName: 'Gutter',
				group: 'Layout',
				type: sizes,
				default: 'md',
			}),
			getPortDef({
				name: 'align',
				displayName: 'Align',
				group: 'Layout',
				type: [
					{ label: 'Stretch', value: 'stretch' },
					{ label: 'Flex start', value: 'flex-start' },
					{ label: 'Center', value: 'center' },
					{ label: 'Flex end', value: 'flex-end' }
				],
				default: 'flex-start',
			}),
			getPortDef({
				name: 'justify',
				displayName: 'Justify',
				group: 'Layout',
				type: [
					{ label: 'Flex start', value: 'flex-start' },
					{ label: 'Center', value: 'center' },
					{ label: 'Flex end', value: 'flex-end' },
					{ label: 'Space between', value: 'space-between' },
					{ label: 'Space around', value: 'space-around' },
				],
				default: 'flex-start',
			}),

			getPortDef({ name: 'opacity', displayName: 'Opacity', group: 'Styles', type: 'number', default: 1 }),
			...margins,
			...paddings
		],
	},
} satisfies ReactNodeDef